import React, { useEffect, useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { Sidebar, Menu, MenuItem, SubMenu, useProSidebar } from 'react-pro-sidebar';
import { People } from '@material-ui/icons';
import ReceiptIcon from '@material-ui/icons/Receipt';
import DescriptionIcon from '@material-ui/icons/Description';
import AssessmentIcon from '@material-ui/icons/Assessment';
import ImportExportIcon from '@material-ui/icons/ImportExport';
import InfoIcon from '@material-ui/icons/Info';
import AccountBoxIcon from '@material-ui/icons/AccountBox';
import AccountBalanceWalletIcon from '@material-ui/icons/AccountBalanceWallet';
import DonutLargeIcon from '@material-ui/icons/DonutLarge';
import AccountCircleIcon from '@material-ui/icons/AccountCircle';
import ViewDayIcon from '@material-ui/icons/ViewDay';
import AccountTreeIcon from '@material-ui/icons/AccountTree';
import CategoryIcon from '@material-ui/icons/Category';
import HomeIcon from '@material-ui/icons/Home';
import AssignmentIcon from '@material-ui/icons/Assignment';
import $ from 'jquery'
import { Tooltip } from 'react-tippy';
import 'react-tippy/dist/tippy.css'
import PaymentIcon from '@material-ui/icons/Payment';
import { isMobile } from 'react-device-detect';
import PersonIcon from '@material-ui/icons/Person';
import TuneIcon from '@material-ui/icons/Tune';
import SettingsInputHdmiIcon from '@material-ui/icons/SettingsInputHdmi';
import SubscriptionsIcon from '@material-ui/icons/Subscriptions';
import AccountBalanceIcon from '@material-ui/icons/AccountBalance';

import { getTrans as t } from "../Localization/translations";
import { useSubscriptionFeatures } from "../contexts/SubscriptionContext";
function Sidebarc({ menuShowHide, setMenuShowHide, customerPermission, rtl, setRtl }) {
  const { planFeatures } = useSubscriptionFeatures();
  // const isCardDisabled = planFeatures !== null && planFeatures.payments_cards === false;
  const location = useLocation();
  const permissions = localStorage.getItem('permissions')
  const [permissionss, setPermission] = useState(localStorage.getItem('permissions'))
  const [permissionsArray, setPermissionsArray] = useState(permissionss ? permissionss.split(',') : [])
  const [activeTab, setActiveTab] = useState(0);
  const [subMenuTab, setsubMenuTab] = useState()
  const [hide, setshow] = useState(true)
  const [hideSetting, setshowSetting] = useState(true)
  const path = location.pathname;
  const [isResponsive, setIsResponsive] = useState(window.innerWidth <= 768);
  const { collapseSidebar } = useProSidebar();
  // const { toggleSidebar } = useProSidebar();

  const isCardDisabled = planFeatures && planFeatures.payments_cards === false;
  
  useEffect(() => {
    let newActiveTab = -1; // Default value if URL doesn't match any menu item
    if (path === '/') {
      newActiveTab = 0;
    } else if (path === '/party') {
      newActiveTab = 1;
    } else if (path === '/contract') {
      newActiveTab = 2;
    }
    else if (path === '/billing') {
      newActiveTab = 4;
    }
    else if (path === '/invoicepaymnet') {
      newActiveTab = 9;
    }
    else if (path === '/receipts') {
      newActiveTab = 5;
    }
    else if (path === '/reports') {
      newActiveTab = 7;
    }
    else if (path === '/manualaccounting') {
      newActiveTab = 8;
    }

    else if (path === '/itemmaster') {
      newActiveTab = 3;
    }
    else if (path === '/supportticket') {
      setMenuShowHide(true)
      newActiveTab = 11;
    } else if (path === '/processing') {
      setMenuShowHide(true)
      newActiveTab = 12;
    } else if (path === '/ratecard') {
      setMenuShowHide(true)
      newActiveTab = 13;
    } else if (path === 'view_accounts') {
      setMenuShowHide(true)
      newActiveTab = 14;
    } else if (path === 'view_transactiontypes') {
      setMenuShowHide(true)
      newActiveTab = 15;
    } else if (path === '/accountingsetup') {
      setMenuShowHide(true)
      newActiveTab = 16;
    } else if (path === '/paymentstripe') {
      setMenuShowHide(true)
      newActiveTab = 17;
    } else if (path === '/AdditionalFiled') {
      setMenuShowHide(true)
      newActiveTab = 18;
    } else if (path === '/profile') {
      setMenuShowHide(true)
      newActiveTab = 6;
    }
    else if (path === '/import') {
      setMenuShowHide(true)
      newActiveTab = 19;
    }
    else if (path === '/accounts') {
      setMenuShowHide(true)
      newActiveTab = 20;
    }
    else if (path === '/transactiontypes') {
      setMenuShowHide(true)
      newActiveTab = 21;
    }
    else if (path === '/additionalsettings') {
      setMenuShowHide(true)
      newActiveTab = 22;
    }
    else if (path === '/taxrateview') {
      setMenuShowHide(true)
      newActiveTab = 23;
    }
    else if (path === '/categories') {
      setMenuShowHide(true)
      newActiveTab = 24;
    }
    else if (path === '/achprovider') {
      setMenuShowHide(true)
      newActiveTab = 25;
    }
    else if (path === '/achfileview') {
      setMenuShowHide(true)
      newActiveTab = 26;
    }
    setActiveTab(newActiveTab);

  }, [location, path, setMenuShowHide]);

  const [commanStyle, setCommanStyle] = useState({})
  useEffect(() => {
    const pathh = location.pathname;
    if (pathh === '/user') {
      const value = localStorage.getItem('permissions')
      setPermission(localStorage.getItem('permissions'))
      setPermissionsArray(value ? value.split(',') : [])
    }
  }, [location])

  const handleToogle = (event) => {
    setshow(!hide)
    collapseSidebar()
    if (!hide) {
      $('.main-content').css("margin-left", "5rem");
    } else {
      $('.main-content').css("margin-left", "15.6rem");
    }
    // $(document).on('click', '#ps-sidebar-left', function () {
    //   $('.main-content').css("margin-left", "15.6rem");
    // })
  }
  const handleToogleSetting = (event) => {
    setshowSetting(!hideSetting)
    collapseSidebar()
    if (!hideSetting) {
      $('.main-content').css("margin-right", "5rem");
    } else {
      $('.main-content').css("margin-right", "15.6rem");
    }
    // $(document).on('click', '#ps-sidebar-right', function () {
    //   $('.main-content').css("margin-right", "15.6rem");
    // })
  }
  const handleToogleclos = (event) => {
    setshow(!hide)
    collapseSidebar()
    if (!hide) {
      $('.main-content').css("margin-left", "5rem");
    } else {
      $('.main-content').css("margin-left", "15.6rem");
    }
    // $(document).on('click', '#ps-sidebar-left', function () {
    //   $('.main-content').css("margin-left", "5rem");
    // })
  }

  useEffect(() => {
    const handleResize = () => {
      const screenWidth = window.innerWidth;
      const mainContent = document.querySelector('.main-content');
      setIsResponsive(window.innerWidth <= 768);
      if (mainContent) {
        if (screenWidth <= 480) {
          mainContent.style.marginRight = "0";
          mainContent.style.marginLeft = "0";
        } else {
          if (!hideSetting) {
            mainContent.style.marginRight = "15.6rem";
            mainContent.style.marginLeft = "0";
          } else {
            if (rtl) {
              mainContent.style.marginRight = "5rem";
            } else {
              mainContent.style.marginRight = "0rem";
            }
            mainContent.style.marginLeft = "5rem";
          }
        }
      }
    };

    handleResize(); // Run on mount

    window.addEventListener('resize', handleResize);

    return () => window.removeEventListener('resize', handleResize);
  }, [hideSetting, rtl]);

  const handleTooglecloseSetting = (event) => {
    setshowSetting(!hideSetting)
    collapseSidebar()
    if (!hideSetting) {
      $('.main-content').css("margin-right", "5rem");
    } else {
      $('.main-content').css("margin-right", "15.6rem");
    }
    // $(document).on('click', '#ps-sidebar-right', function () {
    //   $('.main-content').css("margin-right", "5rem");
    // })
  }


  useEffect(() => {
    const val = location.pathname
    if (val === '/profile' || val === '/processing' || val === '/import' || val === '/ratecard' || val === '/paymentstripe' || val === '/AdditionalFiled') {
      // setRtl(true)
    }
  }, [location])

  const handleMenuItemClick = () => {
    setActiveTab(0);
    setMenuShowHide(false);
    setRtl(false);
    // toggleSidebar();
  };

  useEffect(() => {
    const commonStyles = {
      float: rtl ? 'right' : 'left',
      height: "100%",
      color: "white",
      position: 'fixed',
      bottom: 0,
      zIndex: '999',
      transition: '0.3s',
      ...(isMobile ? { width: '100%' } : { top: 0, width: '250px' })
    };
    setCommanStyle(commonStyles)
  }, [rtl])

  return (
    <>
      <Sidebar
        rootStyles={{
          float: 'left',
          height: "100%",
          color: "white",
          position: 'fixed',
          ...(isMobile ? { bottom: 0, width: '100%' } : { top: 0, width: '250px' }),
        }}
        // rootStyles={{ ...commanStyle, top: rtl ? undefined : 0 }}
        defaultCollapsed
        breakPoint="sm"
        id='ps-sidebar-left'
      // hidden={isResponsive ? rtl : false}
      //  className="left-sidebar"
      >
        <Menu>

          <MenuItem icon={hide === true ? <i className="fa  fa-solid fa-bars "
            style={{ fontSize: '22px' }}
            onClick={(e) => handleToogle(e)}></i> : <i className="fa fa-solid fa-xmark "
              style={{ fontSize: '22px' }} onClick={(e) => handleToogleclos(e)}></i>} className=''> </MenuItem>

          {permissions && permissionsArray.includes('can_view_dashboard') === true ? (
            <MenuItem
              className={activeTab === 0 ? "pro-menu-button active" : "pro-menu-button"}
              onClick={() => { setActiveTab(0); setMenuShowHide(false); setRtl(false) }}
              component={<Link to="/" />}
              icon={
                <Tooltip position='right' title='Dashboard'>
                  <div className="menu-icon">
                    <HomeIcon />
                  </div>
                </Tooltip>
              }
            >
              {t('Dashboard')}
            </MenuItem>
          ) : ""}
          {/* {menuShowHide || path === '/profile' ? <MenuItem className={activeTab === 6 ? 'pro-menu-button active' : ""} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/profile" />}
            icon={<Tooltip position='right' title='Profile'><PersonIcon /></Tooltip>}
          > {t("Profile")} </MenuItem> : ""
          } */}
          {
            // menuShowHide || path === '/profile' ?
            // <MenuItem className={activeTab === 11 ? 'pro-menu-button active' : ""} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/supportticket" />}
            //   icon={<Tooltip position='right' title='Support Ticket'><ConfirmationNumberIcon /></Tooltip>}
            // > {t("Support Ticket")} </MenuItem> 
            // ''
            // :
            permissions && permissionsArray.includes('view_party') === true ?
              <MenuItem className={activeTab === 1 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(1); setRtl(false); }} component={<Link to="/party" />}
                icon={<Tooltip position='right' title='Party'>
                  <div className="menu-icon">
                    <People />
                  </div></Tooltip>}
              > {t('Party')} </MenuItem>
              : ""
          }

          {
            // menuShowHide || path === '/profile' ? 
            // permissions && permissionsArray.includes('view_excelfile') === true ?
            //   customerPermission !== 'Customer' &&
            //   <MenuItem className={activeTab === 19 ? 'pro-menu-button active' : ""} onClick={() => setActiveTab(19)} component={<Link to="/import" />}
            //     icon={<Tooltip position='right' title='Import'><ImportExportIcon /></Tooltip>}
            //   > {t("Import")} </MenuItem> : '' : 
            permissions && permissionsArray.includes('view_contract') === true ?
              <MenuItem className={activeTab === 2 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(2); setRtl(false) }} component={<Link to="/contract" />}
                icon={<Tooltip position='right' title='Contract'>
                  <div className="menu-icon">
                    <AssignmentIcon /></div> </Tooltip>}
              >{t('Contracts')}</MenuItem> :
              ""
          }
          {
            // menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_processing') === true ?
            //   customerPermission !== 'Customer' &&
            //   <MenuItem className={activeTab === 12 ? 'pro-menu-button active' : ""} onClick={() => setActiveTab(12)} component={<Link to="/processing" />}
            //     icon={<Tooltip position='right' title='Processing'><DonutLargeIcon /></Tooltip>}
            //   > {t("Processing")} </MenuItem> : '' : 
            permissions && permissionsArray.includes('view_itemmaster') === true ?
              <MenuItem className={activeTab === 3 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(3); setRtl(false) }} component={<Link to="/itemmaster" />}
                // icon={<Tooltip position='right' title='Inventory'><StorageIcon/></Tooltip>}
                icon={<Tooltip position='right' title='Inventory'>
                  <div className="menu-icon">
                    <img className='MuiSvgIcon-root' src={process.env.PUBLIC_URL + '/static/images/inventorylatest (1).png'} alt="inventory" />
                  </div></Tooltip>}
              >{t('Inventory')}</MenuItem>
              : ""
          }
          {
            // menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_ratecardheader') === true ?
            //   customerPermission !== 'Customer' &&
            //   <MenuItem className={activeTab === 13 ? 'pro-menu-button active' : ""} onClick={() => setActiveTab(13)} component={<Link to="/ratecard" />}
            //     icon={<Tooltip position='right' title='Pricing'><ViewDayIcon /></Tooltip>}
            //   >  {t("Pricing")} </MenuItem> : '' : 
            permissions && permissionsArray.includes('view_invoiceheader') === true ?
              <MenuItem className={activeTab === 4 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(4); setRtl(false) }} component={<Link to="/billing" />}
                icon={<Tooltip position='right' title='Invoice'>
                  <div className="menu-icon">
                    <DescriptionIcon />
                  </div></Tooltip>}
              >{isMobile === false ? t('Billing') : t("Invoices")}</MenuItem>
              : ""
          }
          {
            // menuShowHide || path === '/profile' ?
            //   customerPermission !== 'Customer' &&
            //   <SubMenu label="Accounting"
            //     className={(activeTab === 20 || activeTab === 21 || activeTab === 16) ? 'pro-menu-button active' : "pro-menu-button"}
            //     onClick={() =>
            //       path === '/accounts' ? setsubMenuTab(20) : '' ||
            //         path === '/transactiontypes' ? setsubMenuTab(21) : '' ||
            //           path === '/accountingsetup' ? setsubMenuTab(16) : ''
            //     }
            //     icon={<Tooltip position='right' title='Accounting'><AccountCircleIcon /></Tooltip>}>
            //     {permissions && permissionsArray.includes('view_accounts') === true ? <MenuItem className={subMenuTab === 20 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(20)} component={<Link to="/accounts" />}
            //       icon={<Tooltip position='right' title='Accounts'><AccountBoxIcon /></Tooltip>}
            //     > {t("Accounts")}</MenuItem> : ''}
            //     {permissions && permissionsArray.includes('view_transactiontypes') === true ? <MenuItem className={subMenuTab === 21 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(21)} component={<Link to="/transactiontypes" />}
            //       icon={<Tooltip position='right' title='Transaction Types'><AccountBalanceWalletIcon /></Tooltip>}
            //     // >  {t("Transactions Types")}</MenuItem> : ''}
            //     >  {t("Transactions")}</MenuItem> : ''}
            //     {permissions && permissionsArray.includes('view_accountsetup') === true ? <MenuItem className={subMenuTab === 16 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(16)} component={<Link to="/accountingsetup" />}
            //       icon={<Tooltip position='right' title='Accounting Rules'><AccountTreeIcon /></Tooltip>}
            //     // > {t("Accounting Rules")}</MenuItem> : ''}
            //     > {t("Rules")}</MenuItem> : ''}
            //     {/* {<MenuItem className={subMenuTab === 23 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
            //     icon={<Tooltip position='right' title='Tax Rates'><AccountTreeIcon /></Tooltip>}
            //   // > {t("Accounting Rules")}</MenuItem> : ''}
            //   > {t("Tax Rates")}</MenuItem> } */}
            //   </SubMenu> : 
                  
            <MenuItem 
              className={activeTab === 9 ? 'pro-menu-button active' : "pro-menu-button"}            
              onClick={(e) => { 
                if (isCardDisabled) {
                  e.preventDefault(); 
                  return; 
                }
                setActiveTab(9); 
                setRtl(false); 
              }}               
              component={isCardDisabled ? <div /> : <Link to="/invoicepaymnet" />}              
              style={isCardDisabled ? { 
                opacity: 0.5, 
                cursor: 'not-allowed', 
                filter: 'grayscale(100%)',
                pointerEvents: 'auto' 
              } : {}}              
              icon={
                <Tooltip position='right' title={'Payment'}>
                  <div className="menu-icon">
                    <PaymentIcon style={isCardDisabled ? { color: '#9E9E9E' } : {}} />
                  </div>
                </Tooltip>
              }
            >
              {t('Payment')}
            </MenuItem>

          }
          {
            // menuShowHide || path === '/profile' ?
            //   customerPermission !== 'Customer' &&
            //   <MenuItem className={activeTab === 17 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(17)} component={<Link to="/paymentstripe" />}
            //     icon={<Tooltip position='right' title='Subscriptions Payment'><PaymentIcon /></Tooltip>}
            //   >   {t("Subscriptions Payment")} </MenuItem> :
            permissions && permissionsArray.includes("view_receipts") === true ?
              <MenuItem className={activeTab === 5 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(5); setRtl(false) }} component={<Link to="/receipts" />}
                icon={<Tooltip position='right' title='Receipts'>
                  <div className="menu-icon">
                    <ReceiptIcon />
                  </div></Tooltip>}
              >{t('Receipts')}</MenuItem>
              : ""
          }
          {/* {
          menuShowHide || path === '/profile' ?
            permissions && permissionsArray.includes('view_processing') === true ?
              customerPermission !== 'Customer' &&
              <SubMenu
                label="Setting"
                className={(activeTab === 22 || activeTab === 23) ? 'pro-menu-button active' : "pro-menu-button"}
                onClick={() => {
                  if (path === '/additionalsettings') setsubMenuTab(22);
                  if (path === '/taxrateview') setsubMenuTab(23);
                }}
                icon={<Tooltip position='right' title='Setting'><TuneIcon /></Tooltip>}
              >
                <MenuItem
                  className={subMenuTab === 12 ? 'pro-menu-button active' : "pro-menu-button"}
                  onClick={() => setsubMenuTab(12)}
                  component={<Link to="/additionalsettings" />}
                  icon={<Tooltip position='right' title='Global Setting'><SettingsInputHdmiIcon /></Tooltip>}
                >
                  {t("Global Setting")}
                </MenuItem>
                {<MenuItem className={subMenuTab === 23 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
              icon={<Tooltip position='right' title='Tax Rates'><AccountTreeIcon /></Tooltip>}
            > {t("Tax Rates")}</MenuItem> }
              </SubMenu>
              : ''
            : ''
          } */}

          {

            // <MenuItem
            //   className={activeTab === 20 ? 'pro-menu-button active' : "pro-menu-button"}
            //   onClick={() => { setActiveTab(20); setRtl(false) }}
            //   component={<Link to="/expenses" />}
            //   icon={
            //     <Tooltip position='right' title='Expenses'>
            //       <div className="menu-icon">
            //         {/* I am using a direct SVG here so you don't have to import a new Icon component yet */}
            //         <svg style={{ width: '24px', height: '24px', fill: 'currentColor' }} focusable="false" viewBox="0 0 24 24" aria-hidden="true">
            //           <path d="M11.8 10.9c-2.27-.59-3-1.2-3-2.15 0-1.09 1.01-1.85 2.7-1.85 1.78 0 2.44.85 2.5 2.1h2.21c-.07-1.72-1.12-3.3-3.21-3.81V3h-3v2.16c-1.94.42-3.5 1.68-3.5 3.61 0 2.31 1.91 3.46 4.7 4.15 2.5.61 3 1.54 3 2.61 0 1.28-1.05 2.22-3.2 2.22-2.3 0-3.18-1.55-3.2-2.88H8c.04 1.95 1.5 3.3 3.6 3.7V21h3v-2.06c1.39-.31 3-1.4 3-3.66 0-1.99-1.09-3.2-3.8-3.88z"></path>
            //         </svg>
            //       </div>
            //     </Tooltip>
            //   }
            // >
            //   {/* Using the translation function t() to match your code */}
            //   {t('Expenses')}
            // </MenuItem>
          }
          {

            permissions && permissionsArray.includes('can_view_reports') === true ?
              <MenuItem className={activeTab === 8 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(8); setRtl(false) }} component={<Link to="/transactions" />}
                icon={<Tooltip position='right' title='Transactions'>
                  <div className="menu-icon">
                    <AccountBalanceWalletIcon />
                  </div></Tooltip>}
              >{t('Transactions')}</MenuItem>
              : ""
          }
          {
            // menuShowHide || path === '/profile' && permissions && permissionsArray.includes('view_addextrafiled') === true ?
            //   customerPermission !== 'Customer' &&
            //   <MenuItem className={activeTab === 18 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(18)} component={<Link to="/AdditionalFiled" />}
            //     icon={<Tooltip position='right' title='Additional Information'><InfoIcon /></Tooltip>}
            //   >    {t("Additional Information")} </MenuItem> :
            permissions && permissionsArray.includes('can_view_reports') === true ?
              <MenuItem className={activeTab === 7 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(7); setRtl(false) }} component={<Link to="/reports" />}
                icon={<Tooltip position='right' title='Reports'>
                  <div className="menu-icon">
                    <AssessmentIcon />
                  </div></Tooltip>}
              >{t('Reports')}</MenuItem>
              : ""
          }
          {/* 
          <MenuItem
            className={activeTab === 99 ? 'pro-menu-button active' : "pro-menu-button"}
            onClick={() => {
              setActiveTab(99);
              setMenuShowHide(false);
              setRtl(false); 
            }}
            component={<Link to="/settings" />}
            icon={
              <Tooltip position='right' title='Settings'>
                <div className="menu-icon">
                  <TuneIcon />
                </div>
              </Tooltip>
            }
          >
            {t("Settings")}
          </MenuItem> */}

        </Menu>
      </Sidebar>
      {rtl ?
        <Sidebar
          // rtl={true}
          // rootStyles={{ ...commanStyle, right: 0, backgroundColor: '#818589' }}
          rootStyles={{
            float: isResponsive ? 'left' : 'right',
            height: '100%',
            bottom: 0,
            color: "white",
            position: 'fixed',
            right: 0,
            zIndex: '999',
            transition: '0.3s',
            ...(isMobile ? { bottom: 0, width: '100%' } : { top: 0, width: '250px', right: 0 }),
          }}
          defaultCollapsed
          breakPoint="sm"
          backgroundColor='#818589'
          id='ps-sidebar-right'
        >
          <Menu>
            <MenuItem
              icon={isResponsive ?
                hideSetting === true ? <i className="fa  fa-solid fa-bars " onClick={(e) => handleToogleSetting(e)}></i>
                  : <i className="fa fa-solid fa-xmark" onClick={(e) => handleTooglecloseSetting(e)}></i> : ''}
              className=''>
            </MenuItem>
            {
              permissions && permissionsArray.includes('can_view_dashboard') === true && isResponsive ?
                <MenuItem className={activeTab === 0 ? "pro-menu-button activate" : "pro-menu-button"} onClick={handleMenuItemClick} component={<Link to="/" />}
                  icon={<Tooltip position='right' title='Dashboard'>
                    <div className="menu-icon">
                      <HomeIcon />
                    </div></Tooltip>}
                >{t('Dashboard')}</MenuItem> : ""
            }
            {menuShowHide || path === '/profile' ? <MenuItem className={activeTab === 6 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/profile" />}
              icon={<Tooltip position='right' title='Profile'>
                <div className="menu-icon">
                  <PersonIcon />
                </div></Tooltip>}
            > {t("Profile")} </MenuItem> : ""
            }
            {/* {menuShowHide || path === '/profile' ?
            // <MenuItem className={activeTab === 11 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/supportticket" />}
            //   icon={<Tooltip position='right' title='Support Ticket'><ConfirmationNumberIcon /></Tooltip>}
            // > {t("Support Ticket")} </MenuItem> 
            ''
            :
            permissions && permissionsArray.includes('view_party') === true ?
              <MenuItem className={activeTab === 1 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(1)} component={<Link to="/party" />}
                icon={<Tooltip position='right' title='Party'><People /></Tooltip>}
              > {t('Party')} </MenuItem>
              : ""
          } */}

            {menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_excelfile') === true ?
              customerPermission !== 'Customer' &&
              <MenuItem className={activeTab === 19 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setActiveTab(19)} component={<Link to="/import" />}
                icon={<Tooltip position='right' title='Import'>
                  <div className="menu-icon">
                    <ImportExportIcon />
                  </div></Tooltip>}
              > {t("Import")} </MenuItem> : '' : ''
              // permissions && permissionsArray.includes('view_contract') === true ?
              // <MenuItem className={activeTab === 2 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(2)} component={<Link to="/contract" />}
              //   icon={<Tooltip position='right' title='Contract'><AssignmentIcon /> </Tooltip>}
              // >{t('Contracts')}</MenuItem> :
              // ""
            }

            {menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_processing') === true ?
              customerPermission !== 'Customer' &&
              <MenuItem className={activeTab === 12 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setActiveTab(12)} component={<Link to="/processing" />}
                icon={<Tooltip position='right' title='Processing'>
                  <div className="menu-icon">
                    <DonutLargeIcon />
                  </div></Tooltip>}
              > {t("Processing")} </MenuItem> : '' : ''
              // permissions && permissionsArray.includes('view_itemmaster') === true ?
              // <MenuItem className={activeTab === 3 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(3)} component={<Link to="/itemmaster" />}
              //   // icon={<Tooltip position='right' title='Inventory'><StorageIcon/></Tooltip>}
              //   icon={<Tooltip position='right' title='Inventory'><img className='MuiSvgIcon-root' src={process.env.PUBLIC_URL + '/static/images/inventorylatest (1).png'} alt="inventory" /> </Tooltip>}
              // >{t('Inventory')}</MenuItem>
              // : ""
            }
            {menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_ratecardheader') === true ?
              customerPermission !== 'Customer' &&
              <MenuItem className={activeTab === 13 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setActiveTab(13)} component={<Link to="/ratecard" />}
                icon={<Tooltip position='right' title='Pricing'>
                  <div className="menu-icon">
                    <ViewDayIcon />
                  </div></Tooltip>}
              >  {t("Pricing")} </MenuItem> : '' : ''
              // permissions && permissionsArray.includes('view_invoiceheader') === true ?
              // <MenuItem className={activeTab === 4 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(4)} component={<Link to="/billing" />}
              //   icon={<Tooltip position='right' title='Invoice'><DescriptionIcon /></Tooltip>}
              // >{isMobile === false ? t('Billing') : t("Invoices")}</MenuItem>
              // : ""
            }
            {menuShowHide || path === '/profile' ?
              customerPermission !== 'Customer' &&
              <SubMenu label="Accounting"
                className={(activeTab === 20 || activeTab === 21 || activeTab === 16) ? 'pro-menu-button activate' : "pro-menu-button"}
                onClick={() =>
                  path === '/accounts' ? setsubMenuTab(20) : '' ||
                    path === '/transactiontypes' ? setsubMenuTab(21) : '' ||
                      path === '/accountingsetup' ? setsubMenuTab(16) : ''
                }
                icon={<Tooltip position='right' title='Accounting'><AccountCircleIcon /></Tooltip>}>
                {permissions && permissionsArray.includes('view_accounts') === true ? <MenuItem
                  style={{ backgroundColor: '#818589' }}
                  className={subMenuTab === 20 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(20)} component={<Link to="/accounts" />}
                  icon={<Tooltip position='right' title='Accounts'><AccountBoxIcon /></Tooltip>}
                > {t("Accounts")}</MenuItem> : ''}
                {permissions && permissionsArray.includes('view_transactiontypes') === true ? <MenuItem
                  style={{ backgroundColor: '#818589' }}
                  className={subMenuTab === 21 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(21)} component={<Link to="/transactiontypes" />}
                  icon={<Tooltip position='right' title='Transaction Types'><AccountBalanceWalletIcon /></Tooltip>}
                // >  {t("Transactions Types")}</MenuItem> : ''}
                >  {t("Transactions")}</MenuItem> : ''}
                {permissions && permissionsArray.includes('view_accountsetup') === true ? <MenuItem
                  style={{ backgroundColor: '#818589' }}
                  className={subMenuTab === 16 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(16)} component={<Link to="/accountingsetup" />}
                  icon={<Tooltip position='right' title='Accounting Rules'><AccountTreeIcon /></Tooltip>}
                // > {t("Accounting Rules")}</MenuItem> : ''}
                > {t("Rules")}</MenuItem> : ''}
                {/* {<MenuItem className={subMenuTab === 23 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
              icon={<Tooltip position='right' title='Tax Rates'><AccountTreeIcon /></Tooltip>}
            // > {t("Accounting Rules")}</MenuItem> : ''}
            > {t("Tax Rates")}</MenuItem> } */}
              </SubMenu> : ''
              // <MenuItem className={activeTab === 9 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(9)} component={<Link to="/invoicepaymnet" />}
              //   icon={<Tooltip position='right' title='Payment'><PaymentIcon /></Tooltip>}
              // >{t('Payment')}</MenuItem>

            }
            {menuShowHide || path === '/profile' ?
              customerPermission !== 'Customer' &&
              <SubMenu label="Payments"
                className={(activeTab === 17 || activeTab === 25) ? 'pro-menu-button activate' : "pro-menu-button"}
                onClick={() => {
                  if (path === '/paymentstripe') setsubMenuTab(17);
                  if (path === '/achprovider') setsubMenuTab(25);
                  if (path === '/achfileview') setsubMenuTab(26);
                }}

                icon={<Tooltip position='right' title='Payments'>
                  <div className="menu-icon">
                    {/* <TuneIcon /> */}
                    <PaymentIcon />

                  </div></Tooltip>}
              >
                <MenuItem
                  style={{ backgroundColor: '#818589' }}

                  className={subMenuTab === 17 ? 'pro-menu-button activate' : "pro-menu-button"}
                  onClick={() => setsubMenuTab(17)}
                  component={<Link to="/paymentstripe" />}
                  icon={<Tooltip position='right' title='Subscriptions Payment'>
                    <div className="menu-icon">
                      <SubscriptionsIcon />
                    </div>
                  </Tooltip>}
                >   {t("Subscriptions Payment")} </MenuItem>

                {/* // permissions && permissionsArray.includes("view_receipts") === true ?
              //   <MenuItem className={activeTab === 5 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(5)} component={<Link to="/receipts" />}
              //     icon={<Tooltip position='right' title='Receipts'><ReceiptIcon /> </Tooltip>}
              //   >{t('Receipts')}</MenuItem>
              //   : "" */}
                {<MenuItem
                  style={{ backgroundColor: '#818589' }}
                  className={subMenuTab === 25 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(25)} component={<Link to="/achproviders" />}
                  icon={<Tooltip position='right' title='ACH Provider'>
                    <div className="menu-icon">
                      <AccountBalanceIcon />
                    </div></Tooltip>}
                > {t("ACH Provider")}</MenuItem>}
                {<MenuItem
                  style={{ backgroundColor: '#818589' }}
                  className={subMenuTab === 26 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(26)} component={<Link to="/achfileview" />}
                  icon={<Tooltip position='right' title='ACH File'>
                    <div className="menu-icon">
                      <AccountBalanceIcon />
                    </div></Tooltip>}
                > {t("ACH File")}</MenuItem>}
              </SubMenu>
              : ""
            }
            {menuShowHide || path === '/profile' ?
              permissions && permissionsArray.includes('view_processing') === true ?
                customerPermission !== 'Customer' &&
                <SubMenu
                  label="Setting"
                  className={(activeTab === 22 || activeTab === 23) ? 'pro-menu-button activate' : "pro-menu-button"}
                  onClick={() => {
                    if (path === '/additionalsettings') setsubMenuTab(22);
                    if (path === '/taxrateview') setsubMenuTab(23);
                  }}
                  icon={<Tooltip position='right' title='Setting'>
                    <div className="menu-icon">
                      <TuneIcon />
                    </div></Tooltip>}
                >
                  <MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 22 ? 'pro-menu-button activate' : "pro-menu-button"}
                    onClick={() => setsubMenuTab(22)}
                    component={<Link to="/additionalsettings" />}
                    icon={<Tooltip position='right' title='Global Setting'>
                      <div className="menu-icon">
                        <SettingsInputHdmiIcon />
                      </div></Tooltip>}
                  >
                    {t("Global Setting")}
                  </MenuItem>
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 23 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
                    icon={<Tooltip position='right' title='Tax Rates'>
                      <div className="menu-icon">
                        <AccountTreeIcon />
                      </div></Tooltip>}
                  > {t("Tax Rates")}</MenuItem>}
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 24 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(24)} component={<Link to="/categories" />}
                    icon={<Tooltip position='right' title='Categories'>
                      <div className="menu-icon">
                        <CategoryIcon />
                      </div></Tooltip>}
                  > {t("Categories")}</MenuItem>}
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 24 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(24)} component={<Link to="/expense-categories" />}
                    icon={<Tooltip position='right' title='Expenses Categories'>
                      <div className="menu-icon">
                        <CategoryIcon />
                      </div></Tooltip>}
                  > {t("Expenses Categories")}</MenuItem>}
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 24 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(24)} component={<Link to="/reporttemplates" />}
                    icon={<Tooltip position='right' title='Report Templates'>
                      <div className="menu-icon">
                        <CategoryIcon />
                      </div></Tooltip>}
                  > {t("Report Templates")}</MenuItem>}
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 24 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(24)} component={<Link to="/json" />}
                    icon={<Tooltip position='right' title='Orignation Platform'>
                      <div className="menu-icon">
                        <CategoryIcon />
                      </div></Tooltip>}
                  > {t("Orignation Platform")}</MenuItem>}
                  {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 24 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(24)} component={<Link to="/emailtemplets" />}
                    icon={<Tooltip position='right' title='Email Formator'>
                      <div className="menu-icon">
                        <CategoryIcon />
                      </div></Tooltip>}
                  > {t("Email Templates")}</MenuItem>}
                  {/* {<MenuItem
                    style={{ backgroundColor: '#818589' }}
                    className={subMenuTab === 25 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setsubMenuTab(25)} component={<Link to="/achproviders" />}
                    icon={<Tooltip position='right' title='ACH Provider'>
                   <div className="menu-icon">
                   <CategoryIcon />
                   </div></Tooltip>}
                  > {t("ACH Proivder")}</MenuItem>} */}
                </SubMenu>
                : ''
              : ''
            }
            {menuShowHide || path === '/profile' && permissions && permissionsArray.includes('view_addextrafiled') === true ?
              customerPermission !== 'Customer' &&
              <MenuItem className={activeTab === 18 ? 'pro-menu-button activate' : "pro-menu-button"} onClick={() => setActiveTab(18)} component={<Link to="/AdditionalFiled" />}
                icon={<Tooltip position='right' title='Additional Information'>
                  <div className="menu-icon">
                    <InfoIcon />
                  </div></Tooltip>}
              >    {t("Additional Information")} </MenuItem> : ''
              // permissions && permissionsArray.includes('can_view_reports') === true ?
              //   <MenuItem className={activeTab === 7 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(7)} component={<Link to="/reports" />}
              //     icon={<Tooltip position='right' title='Reports'><AssessmentIcon /></Tooltip>}
              //   >{t('Reports')}</MenuItem>
              //   : ""
            }
          </Menu>
        </Sidebar>
        : isMobile &&
        <Sidebar
          // rootStyles={{
          //   float: 'left',
          //   height: "100%",
          //   color: "white",
          //   position: 'fixed',
          //   ...(isMobile ? { bottom: 0, width: '100%' } : { top: 0, width: '250px' }),
          // }}
          rootStyles={{ ...commanStyle, top: rtl ? undefined : 0 }}
          defaultCollapsed
          breakPoint="sm"
          id='ps-sidebar-left'
          hidden={isResponsive ? rtl : false}
        >
          <Menu>

            <MenuItem icon={hide === true ? <i className="fa  fa-solid fa-bars " onClick={(e) => handleToogle(e)}></i> : <i className="fa fa-solid fa-xmark" onClick={(e) => handleToogleclos(e)}></i>} className=''> </MenuItem>
            {
              permissions && permissionsArray.includes('can_view_dashboard') === true ?
                <MenuItem className={activeTab === 0 ? "pro-menu-button active" : "pro-menu-button"} onClick={() => { setActiveTab(0); setMenuShowHide(false); setRtl(false) }} component={<Link to="/" />}
                  icon={<Tooltip position='right' title='Dashboard'>
                    <div className="menu-icon">
                      <HomeIcon />
                    </div></Tooltip>}
                >{t('Dashboard')}</MenuItem> : ""
            }
            {/* {menuShowHide || path === '/profile' ? <MenuItem className={activeTab === 6 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/profile" />}
            icon={<Tooltip position='right' title='Profile'><PersonIcon /></Tooltip>}
          > {t("Profile")} </MenuItem> : ""
          } */}
            {
              // menuShowHide || path === '/profile' ?
              // <MenuItem className={activeTab === 11 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(11); setMenuShowHide(true) }} component={<Link to="/supportticket" />}
              //   icon={<Tooltip position='right' title='Support Ticket'><ConfirmationNumberIcon /></Tooltip>}
              // > {t("Support Ticket")} </MenuItem> 
              // ''
              // :
              permissions && permissionsArray.includes('view_party') === true ?
                <MenuItem className={activeTab === 1 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(1); setRtl(false); }} component={<Link to="/party" />}
                  icon={<Tooltip position='right' title='Party'>
                    <div className="menu-icon">
                      <People />
                    </div></Tooltip>}
                > {t('Party')} </MenuItem>
                : ""
            }

            {
              // menuShowHide || path === '/profile' ? 
              // permissions && permissionsArray.includes('view_excelfile') === true ?
              //   customerPermission !== 'Customer' &&
              //   <MenuItem className={activeTab === 19 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(19)} component={<Link to="/import" />}
              //     icon={<Tooltip position='right' title='Import'><ImportExportIcon /></Tooltip>}
              //   > {t("Import")} </MenuItem> : '' : 
              permissions && permissionsArray.includes('view_contract') === true ?
                <MenuItem className={activeTab === 2 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(2); setRtl(false) }} component={<Link to="/contract" />}
                  icon={<Tooltip position='right' title='Contract'>
                    <div className="menu-icon">
                      <AssignmentIcon /></div> </Tooltip>}
                >{t('Contracts')}</MenuItem> :
                ""
            }
            {
              // menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_processing') === true ?
              //   customerPermission !== 'Customer' &&
              //   <MenuItem className={activeTab === 12 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(12)} component={<Link to="/processing" />}
              //     icon={<Tooltip position='right' title='Processing'><DonutLargeIcon /></Tooltip>}
              //   > {t("Processing")} </MenuItem> : '' : 
              permissions && permissionsArray.includes('view_itemmaster') === true ?
                <MenuItem className={activeTab === 3 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(3); setRtl(false) }} component={<Link to="/itemmaster" />}
                  // icon={<Tooltip position='right' title='Inventory'><StorageIcon/></Tooltip>}
                  icon={<Tooltip position='right' title='Inventory'>
                    <div className="menu-icon">
                      <img className='MuiSvgIcon-root' src={process.env.PUBLIC_URL + '/static/images/inventorylatest (1).png'} alt="inventory" />
                    </div></Tooltip>}
                >{t('Inventory')}</MenuItem>
                : ""
            }
            {
              // menuShowHide || path === '/profile' ? permissions && permissionsArray.includes('view_ratecardheader') === true ?
              //   customerPermission !== 'Customer' &&
              //   <MenuItem className={activeTab === 13 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(13)} component={<Link to="/ratecard" />}
              //     icon={<Tooltip position='right' title='Pricing'><ViewDayIcon /></Tooltip>}
              //   >  {t("Pricing")} </MenuItem> : '' : 
              permissions && permissionsArray.includes('view_invoiceheader') === true ?
                <MenuItem className={activeTab === 4 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(4); setRtl(false) }} component={<Link to="/billing" />}
                  icon={<Tooltip position='right' title='Invoice'>
                    <div className="menu-icon">
                      <DescriptionIcon />
                    </div></Tooltip>}
                >{isMobile === false ? t('Billing') : t("Invoices")}</MenuItem>
                : ""
            }
            {
              // menuShowHide || path === '/profile' ?
              //   customerPermission !== 'Customer' &&
              //   <SubMenu label="Accounting"
              //     className={(activeTab === 20 || activeTab === 21 || activeTab === 16) ? 'pro-menu-button active' : "pro-menu-button"}
              //     onClick={() =>
              //       path === '/accounts' ? setsubMenuTab(20) : '' ||
              //         path === '/transactiontypes' ? setsubMenuTab(21) : '' ||
              //           path === '/accountingsetup' ? setsubMenuTab(16) : ''
              //     }
              //     icon={<Tooltip position='right' title='Accounting'><AccountCircleIcon /></Tooltip>}>
              //     {permissions && permissionsArray.includes('view_accounts') === true ? <MenuItem className={subMenuTab === 20 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(20)} component={<Link to="/accounts" />}
              //       icon={<Tooltip position='right' title='Accounts'><AccountBoxIcon /></Tooltip>}
              //     > {t("Accounts")}</MenuItem> : ''}
              //     {permissions && permissionsArray.includes('view_transactiontypes') === true ? <MenuItem className={subMenuTab === 21 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(21)} component={<Link to="/transactiontypes" />}
              //       icon={<Tooltip position='right' title='Transaction Types'><AccountBalanceWalletIcon /></Tooltip>}
              //     // >  {t("Transactions Types")}</MenuItem> : ''}
              //     >  {t("Transactions")}</MenuItem> : ''}
              //     {permissions && permissionsArray.includes('view_accountsetup') === true ? <MenuItem className={subMenuTab === 16 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(16)} component={<Link to="/accountingsetup" />}
              //       icon={<Tooltip position='right' title='Accounting Rules'><AccountTreeIcon /></Tooltip>}
              //     // > {t("Accounting Rules")}</MenuItem> : ''}
              //     > {t("Rules")}</MenuItem> : ''}
              //     {/* {<MenuItem className={subMenuTab === 23 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
              //     icon={<Tooltip position='right' title='Tax Rates'><AccountTreeIcon /></Tooltip>}
              //   // > {t("Accounting Rules")}</MenuItem> : ''}
              //   > {t("Tax Rates")}</MenuItem> } */}
              //   </SubMenu> : 
              <MenuItem className={activeTab === 9 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(9); setRtl(false) }} component={<Link to="/invoicepaymnet" />}
                icon={<Tooltip position='right' title='Payment'>
                  <div className="menu-icon">
                    <PaymentIcon />
                  </div></Tooltip>}
              >{t('Payment')}</MenuItem>

            }
            {
              // menuShowHide || path === '/profile' ?
              //   customerPermission !== 'Customer' &&
              //   <MenuItem className={activeTab === 17 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(17)} component={<Link to="/paymentstripe" />}
              //     icon={<Tooltip position='right' title='Subscriptions Payment'><PaymentIcon /></Tooltip>}
              //   >   {t("Subscriptions Payment")} </MenuItem> :
              permissions && permissionsArray.includes("view_receipts") === true ?
                <MenuItem className={activeTab === 5 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(5); setRtl(false) }} component={<Link to="/receipts" />}
                  icon={<Tooltip position='right' title='Receipts'>
                    <div className="menu-icon">
                      <ReceiptIcon />
                    </div> </Tooltip>}
                >{t('Receipts')}</MenuItem>
                : ""
            }
            {/* {
          menuShowHide || path === '/profile' ?
            permissions && permissionsArray.includes('view_processing') === true ?
              customerPermission !== 'Customer' &&
              <SubMenu
                label="Setting"
                className={(activeTab === 22 || activeTab === 23) ? 'pro-menu-button active' : "pro-menu-button"}
                onClick={() => {
                  if (path === '/additionalsettings') setsubMenuTab(22);
                  if (path === '/taxrateview') setsubMenuTab(23);
                }}
                icon={<Tooltip position='right' title='Setting'><TuneIcon /></Tooltip>}
              >
                <MenuItem
                  className={subMenuTab === 12 ? 'pro-menu-button active' : "pro-menu-button"}
                  onClick={() => setsubMenuTab(12)}
                  component={<Link to="/additionalsettings" />}
                  icon={<Tooltip position='right' title='Global Setting'><SettingsInputHdmiIcon /></Tooltip>}
                >
                  {t("Global Setting")}
                </MenuItem>
                {<MenuItem className={subMenuTab === 23 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setsubMenuTab(23)} component={<Link to="/taxrateview" />}
              icon={<Tooltip position='right' title='Tax Rates'><AccountTreeIcon /></Tooltip>}
            > {t("Tax Rates")}</MenuItem> }
              </SubMenu>
              : ''
            : ''
          } */}

            {

              permissions && permissionsArray.includes('can_view_reports') === true ?
                <MenuItem className={activeTab === 8 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(8); setRtl(false) }} component={<Link to="/transactions" />}
                  icon={<Tooltip position='right' title='Transactions'>
                    <div className="menu-icon">
                      <AccountBalanceWalletIcon />
                    </div></Tooltip>}
                >{t('Transactions')}</MenuItem>
                : ""
            }
            {
              // menuShowHide || path === '/profile' && permissions && permissionsArray.includes('view_addextrafiled') === true ?
              //   customerPermission !== 'Customer' &&
              //   <MenuItem className={activeTab === 18 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => setActiveTab(18)} component={<Link to="/AdditionalFiled" />}
              //     icon={<Tooltip position='right' title='Additional Information'><InfoIcon /></Tooltip>}
              //   >    {t("Additional Information")} </MenuItem> :
              permissions && permissionsArray.includes('can_view_reports') === true ?
                <MenuItem className={activeTab === 7 ? 'pro-menu-button active' : "pro-menu-button"} onClick={() => { setActiveTab(7); setRtl(false) }} component={<Link to="/reports" />}
                  icon={<Tooltip position='right' title='Reports'>
                    <div className="menu-icon">
                      <AssessmentIcon />
                    </div></Tooltip>}
                >{t('Reports')}</MenuItem>
                : ""
            }
          </Menu>
        </Sidebar>
      }
    </>
  )
}

export default Sidebarc
